import { Chip } from '@mui/material';

type StatusChipProps = {
  codeId: string;
  name: string;
  color?: string;
};

const StatusChip = ({ codeId, name, color }: StatusChipProps) => {
  return (
    <Chip
      data-testid="status-chip"
      label={`${codeId} ${name}`}
      sx={{ backgroundColor: color || ' rgb(251, 251, 251)' }}
    />
  );
};

export default StatusChip;
